import About from 'Pages/AboutUs.vue';
import AdvertiseWithUs from 'Pages/AdvertiseWithUsPage.vue';
import AllLocations from 'Pages/AllLocations.vue';
import ContactUs from 'Pages/ContactUs.vue';
import CookiePolicy from 'Pages/CookiePolicy.vue';
import Index from 'Pages/Index.vue';
import PrivacyPolicy from 'Pages/PrivacyPolicy.vue';
import Search from 'Pages/Search.vue';
import SearchForAgencies from 'Pages/SearchForAgencies';
import EmployerDetails from 'Pages/EmployerDetails.vue';
import EmployerCallback from 'Pages/EmployerCallback.vue';
import PersonalPage from "Pages/PersonalPage.vue";
import HowToUse from "Pages/HowToUse.vue";

export default [
  {
    path: '/',
    name: 'home',
    component: Index,
    meta: {
      head: {
        title: 'Find Recruitment Agencies at Agency Central',
        links: [
          {
            rel: 'canonical',
            href: 'https://agencycentral.co.uk',
          },
        ],
        meta: [
          {
            name: 'description',
            content: 'Something about AC',
          },
        ],
      },
    },
  },
  {
    name: 'searchForAgencies',
    path: '/search-for-agencies',
    component: SearchForAgencies,
  },
  {
    name: 'allLocations',
    path: '/agencysearch/bylocation.htm',
    component: AllLocations,
  },
  {
    name: 'bytown',
    path: '/agencysearch/bytown/:townLocator.htm',
    component: Search,
    props: {
      default: true,
      static: true,
    },
  },
  {
    name: 'bycounty',
    path: '/agencysearch/bycounty/:countyLocator.htm',
    component: Search,
    props: {
      default: true,
      static: true,
    },
  },
  {
    name: 'byregion',
    path: '/agencysearch/byregion/:regionLocator.htm',
    component: Search,
    props: {
      default: true,
      static: true,
    },
  },
  {
    name: 'byindustry',
    path: '/agencysearch/:industry/agencysearch.htm',
    component: Search,
    props: {
      default: true,
      static: true,
    },
  },
  {
    name: 'byindustrycounty',
    path: '/agencysearch/:industry/countysearch/:country/:county.htm',
    component: Search,
    props: {
      default: true,
      static: true,
    },
  },
  {
    name: 'byindustryskill',
    path: '/agencysearch/:industry/skills/:skill/:subcat.htm',
    component: Search,
    props: {
      default: true,
      static: true,
    },
  },
  {
    name: 'byindustrytown',
    path: '/localsearch/:industry-recruitment-agencies-in:town',
    component: Search,
    props: {
      default: true,
      static: true,
    },
  },
  {
    name: 'search',
    path: '/agencysearch/search.htm',
    component: Search,
    props: {
        static: false,
    }
  },
  {
    name: "personalpage",
    path: "/recruitment-agency/:agency_slug/:tag",
    component: PersonalPage,
  },
  {
    name: 'cookiePolicy',
    path: '/cookie-policy',
    component: CookiePolicy,
  },
  {
    name: 'advertise-with-us',
    path: '/agencyarea/index.html',
    component: AdvertiseWithUs,
    // meta: {
    //     head: {
    //       title: 'Online Recruitment Advertising',
    //       links: [
    //         {
    //           rel: 'canonical',
    //           href: 'https://agencycentral.co.uk',
    //         },
    //       ],
    //       meta: [
    //         {
    //           name: 'description',
    //           content: 'Something about AC',
    //         },
    //       ],
    //     },
    //   },  
  },
  {
    name: 'contact',
    path: '/contactus/index.html',
    component: ContactUs,
  },
  {
    name: 'privacyPolicy',
    path: '/contact-us/articles/privacy-policy.htm',
    component: PrivacyPolicy,
  },
  {
    name: 'howToUse',
    path: '/howtouse/index.html',
    component: HowToUse,
  },
  {
    name: 'howToUseLong',
    path: '/howtouse/how-to-use.htm',
    component: HowToUse,
  },
  {
    name: 'about',
    path: '/contact-us/articles/about-us.htm',
    component: About,
  },
  {
    name: 'employerDetails',
    path: '/employers/details',
    component: EmployerDetails,
  },
  {
    name: 'employerCallback',
    path: '/employers/callback',
    component: EmployerCallback,
  },
  {
    name: 'socialLeaderboards',
    path: '/social-leaderboards',
    beforeEnter() {
        location.href = 'http://www.agencycentral.co.uk/social-leaderboards';
    }
  },
  {
    name: 'articles',
    path: '/articles:pathMatch(.*)',
    beforeEnter(to) {
        location.href = 'http://www.agencycentral.co.uk/articles' + to.params.pathMatch;
    }
  },
  {
    // TODO: 404
    name: 'not-found',
    path: '/:pathMatch(.*)*',
    component: Index,
  },
];
